// extracted by mini-css-extract-plugin
export default {"body":"arin_body__6EJfR","content":"arin_content__4Rvdu","img":"arin_img__9lnPD"};